import { render, staticRenderFns } from "./AddDeliverNote.vue?vue&type=template&id=83f1efa0&"
import script from "./AddDeliverNote.vue?vue&type=script&lang=ts&"
export * from "./AddDeliverNote.vue?vue&type=script&lang=ts&"
import style0 from "./AddDeliverNote.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports